import { render, staticRenderFns } from "./TrainingApproveModal.vue?vue&type=template&id=767e4d56&scoped=true&"
import script from "./TrainingApproveModal.vue?vue&type=script&lang=js&"
export * from "./TrainingApproveModal.vue?vue&type=script&lang=js&"
import style0 from "./TrainingApproveModal.vue?vue&type=style&index=0&id=767e4d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767e4d56",
  null
  
)

export default component.exports